import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1abca992"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gd-user-relationship mb-gutter" }
const _hoisted_2 = { class: "form-field form-field--gd" }
const _hoisted_3 = { class: "field-row" }
const _hoisted_4 = { class: "label label--inline label--multi-line" }
const _hoisted_5 = { class: "field-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label label--text label--inline label--multi-line" }, null, -1))
const _hoisted_7 = { class: "gd-field-multi-select form-field--gd__options" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-checkbox" }, null, -1))
const _hoisted_10 = {
  class: "label label--inline label-padding",
  "data-auto": "custemprelation-IsCustomer-lbl"
}
const _hoisted_11 = { class: "label--fixedwidth" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-checkbox top-align" }, null, -1))
const _hoisted_14 = {
  class: "label label--inline span--inherit label-padding",
  "data-auto": "custemprelation-IsEmployee-lbl"
}
const _hoisted_15 = {
  key: 0,
  class: "mb-gutter"
}
const _hoisted_16 = { class: "form-field form-field--gd" }
const _hoisted_17 = { class: "field-row" }
const _hoisted_18 = {
  class: "label label--text label--inline",
  "data-auto": "customernumber-lbl"
}
const _hoisted_19 = ["disabled", "placeholder"]
const _hoisted_20 = { class: "form-field form-field--gd" }
const _hoisted_21 = { class: "field-row" }
const _hoisted_22 = {
  class: "label label--text label--inline",
  "data-auto": "ordernumber-lbl"
}
const _hoisted_23 = ["disabled", "placeholder"]
const _hoisted_24 = { class: "form-field form-field--gd" }
const _hoisted_25 = { class: "field-row" }
const _hoisted_26 = {
  class: "label label--text label--inline",
  "data-auto": "complaintref-lbl"
}
const _hoisted_27 = ["disabled", "placeholder"]
const _hoisted_28 = {
  key: 1,
  class: "mb-gutter"
}
const _hoisted_29 = { class: "form-field form-field--gd" }
const _hoisted_30 = { class: "field-row" }
const _hoisted_31 = {
  class: "label label--text label--inline",
  "data-auto": "employeenumber-lbl"
}
const _hoisted_32 = ["disabled", "placeholder"]
const _hoisted_33 = { class: "form-field form-field--gd" }
const _hoisted_34 = { class: "field-row" }
const _hoisted_35 = {
  class: "label label--text label--inline",
  "data-auto": "empstartdate-lbl"
}
const _hoisted_36 = { class: "form-field form-field--gd" }
const _hoisted_37 = { class: "field-row" }
const _hoisted_38 = {
  class: "label label--text label--inline",
  "data-auto": "empenddate-lbl"
}
const _hoisted_39 = { class: "form-field form-field--gd" }
const _hoisted_40 = { class: "field-row" }
const _hoisted_41 = {
  class: "label label--text label--inline",
  "data-auto": "storehofunction-lbl"
}
const _hoisted_42 = ["disabled", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("labeltext.relationshipDetailsText", {
              brandPlcName1: _ctx.initModel.brandPlcName,
            })), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "IsCustomer",
              value: "true",
              name: "custemprelation",
              disabled: _ctx.initModel.isDisabled,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newUser.IsCustomerCheckbox) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearInputFieldsCustomerEmployee && _ctx.clearInputFieldsCustomerEmployee(...args)))
            }, null, 40, _hoisted_8), [
              [_vModelCheckbox, _ctx.newUser.IsCustomerCheckbox]
            ]),
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("labeltext.customer")), 1)
          ]),
          _createElementVNode("label", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "IsEmployee",
              value: "true",
              name: "custemprelation",
              disabled: _ctx.initModel.isDisabled,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newUser.IsEmployeeCheckbox) = $event)),
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearInputFieldsCustomerEmployee && _ctx.clearInputFieldsCustomerEmployee(...args)))
            }, null, 40, _hoisted_12), [
              [_vModelCheckbox, _ctx.newUser.IsEmployeeCheckbox]
            ]),
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("labeltext.employee", {
                  brandPlcName: _ctx.initModel.brandPlcName,
                })), 1)
          ])
        ])
      ])
    ]),
    (_ctx.newUser.IsCustomerCheckbox.toString() === 'true')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("labeltext.custNo")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newUser.CustomerNumber) = $event)),
                disabled: _ctx.initModel.isDisabled,
                placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.custNo')
            ,
                name: "customernumber",
                maxlength: "25"
              }, null, 8, _hoisted_19), [
                [_vModelText, _ctx.newUser.CustomerNumber]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", _hoisted_21, [
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("labeltext.orderNo")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newUser.OrderNumber) = $event)),
                disabled: _ctx.initModel.isDisabled,
                placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.orderNo')
            ,
                name: "ordernumber",
                maxlength: "25"
              }, null, 8, _hoisted_23), [
                [_vModelText, _ctx.newUser.OrderNumber]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("label", _hoisted_25, [
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("labeltext.complainRef")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newUser.ComplaintRefNumber) = $event)),
                disabled: _ctx.initModel.isDisabled,
                placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.complainRef')
            ,
                name: "complaintref",
                maxlength: "25"
              }, null, 8, _hoisted_27), [
                [_vModelText, _ctx.newUser.ComplaintRefNumber]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.newUser.IsEmployeeCheckbox.toString() === 'true')
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("label", _hoisted_30, [
              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("labeltext.empNo")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newUser.EmployeeNumber) = $event)),
                disabled: _ctx.initModel.isDisabled,
                placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.empNo')
            ,
                name: "employeenumber",
                maxlength: "25"
              }, null, 8, _hoisted_32), [
                [_vModelText, _ctx.newUser.EmployeeNumber]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("labeltext.startDate")), 1),
              _createVNode(_component_date_picker, {
                placeholder: 
              _ctx.newUser.StartDT == null && _ctx.initModel.isDisabled
                ? '  '
                : _ctx.translate('labeltext.selectDatePlc')
            ,
                modelValue: _ctx.newUser.StartDT,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newUser.StartDT) = $event)),
                disabled: _ctx.initModel.isDisabled,
                locale: _ctx.initModel.datepickerLang,
                "enable-time-picker": false,
                format: _ctx.dateFormat,
                "auto-apply": "",
                "hide-input-icon": "",
                name: "empstartdate"
              }, null, 8, ["placeholder", "modelValue", "disabled", "locale", "format"])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("labeltext.endDate")), 1),
              _createVNode(_component_date_picker, {
                placeholder: 
              _ctx.newUser.EndDT == null && _ctx.initModel.isDisabled
                ? '  '
                : _ctx.translate('labeltext.selectDatePlc')
            ,
                modelValue: _ctx.newUser.EndDT,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newUser.EndDT) = $event)),
                disabled: _ctx.initModel.isDisabled,
                locale: _ctx.initModel.datepickerLang,
                "enable-time-picker": false,
                format: _ctx.dateFormat,
                "auto-apply": "",
                "hide-input-icon": "",
                name: "empenddate"
              }, null, 8, ["placeholder", "modelValue", "disabled", "locale", "format"])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("label", _hoisted_40, [
              _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("labeltext.storeHeadOff")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newUser.OfficeFunction) = $event)),
                disabled: _ctx.initModel.isDisabled,
                placeholder: 
              _ctx.initModel.isDisabled == true
                ? ''
                : _ctx.translate('labeltext.storeHeadOff')
            ,
                name: "storehofunction",
                maxlength: "100"
              }, null, 8, _hoisted_42), [
                [_vModelText, _ctx.newUser.OfficeFunction]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}